<template>
  <div class="widget w-video-help-center-widget">
    <c-widget-header hideLinkMode :wid="wid">
      <slot name="buttons" slot="buttons" />
    </c-widget-header>

    <div class="widget-body">
      <iframe
        :src="helpCenterURL"
        sandbox="allow-scripts allow-same-origin"
        allowfullscreen="true"
        :title="$t('white-label.widgets.videoHelpCenter.widget-title')"
      >
        <a :href="helpCenterURL">{{ $t('white-label.widgets.videoHelpCenter.widget-title') }}</a>
      </iframe>
    </div>
  </div>
</template>

<script>
import CWidgetHeader from '@custom/widgetContainer/CWidgetHeader';
import CWidgetControlBar from '@custom/widgetContainer/CWidgetControlBar';

export default {
  name: 'w-video-help-center-widget',
  components: { CWidgetHeader, CWidgetControlBar },
  props: {
    wid: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    helpCenterURL() {
      return this.locale === 'en-US'
        ? this.$store.state.widget[this.wid].helpCenterURL
        : this.$store.state.widget[this.wid].helpCenterURLFr;
    },
    locale() {
      return this.$store.state.applicationSettings.general.settings.applicationLanguage;
    }
  }
};
</script>
<style lang="scss">
@import '~@/styles/widgets/videohelpcenter-widget';
</style>
